import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { parseLocale, setLocale } from './locale';

/** Keep `?lang=` in sync with the locale store. */
const LangQuerySync: React.FC = () => {
  const [params] = useSearchParams();
  useEffect(() => {
    const parsed = parseLocale(params.get('lang'));
    if (parsed) setLocale(parsed);
  }, [params]);
  return null;
};

export default LangQuerySync;
